import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider, useDispatch } from 'react-redux';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate
} from 'react-router-dom';
import Main from './pages/main';
import { useTypedSelector } from './hooks/useTypeSelector';
import Login from './pages/login';
import { setTheme } from './redux/actions/themeAction';
import { HideNotificationAction } from './redux/actions/notificationAction';
import Notification from './components/Utils/notification';
import { persistor, store } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ChatScreen from './components/Sections/Messaging';
import { QueryClient, QueryClientProvider } from 'react-query';

const NotifPopup = () => {
	const notification = useTypedSelector((state) => state.notification);
	const dispatch = useDispatch();

	useEffect(() => {
		if (notification.activated) {
			const timeout = setTimeout(() => {
				dispatch(HideNotificationAction());
			}, 3000);

			return () => clearTimeout(timeout);
		}
	}, [notification]);

	return (
		<div
			className={
				notification.activated
					? 'absolute float-left top-24 left-24 z-50 opacity-100 transition-all duration-500'
					: 'absolute float-left top-24 left-24 z-50 opacity-0 scale-0 transition-all duration-500'
			}
			onClick={() => dispatch(HideNotificationAction())}
		>
			<Notification type={notification.type} message={notification.message} />
		</div>
	);
};
const Routing = () => {
	const { isAuthenticated } = useTypedSelector((state) => state.auth);
	const { dark } = useTypedSelector((state) => state.theme);

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setTheme(!dark));
	}, []);

	return (
		<Router>
			<Routes>
				<Route
					path="/login"
					element={isAuthenticated ? <Navigate to="/" /> : <Login />}
				/>
				<Route
					path="/home/*"
					element={isAuthenticated ? <Main /> : <Navigate to="/login" />}
				/>
				<Route path="/chat" element={<ChatScreen />} />
				<Route path="/" element={<Navigate to="/home/main-dashboard" />} />
				<Route path="/Terms_&_Conditions.html" />
			</Routes>
		</Router>
	);
};

const queryClient = new QueryClient({});
ReactDOM.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<NotifPopup />

				<QueryClientProvider client={queryClient}>
					<Routing />
				</QueryClientProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
